import React from 'react';
import { always } from 'ramda';
import { useEffectOnce } from 'react-use';

import { ContentBody } from '@components/contentBody';
import { GeneralPage } from '@definitions/generalPage.types';
import { renderWhenTrueOtherwise } from '@utils/rendering';
import { CenterContainer } from '@components/centerContainer';
import { GENERAL_PAGE_TYPE } from '@components/generalPageView/generalPageView.constants';
import { useMonogram } from '@hooks/useMonogram';

import { Container, alignContentTopStyles } from './generalPageView.styles';

export interface GeneralPageViewProps {
  generalPage: GeneralPage;
}

export const GeneralPageView = ({ generalPage }: GeneralPageViewProps) => {
  const { addMonogram, clearMonogram } = useMonogram();

  useEffectOnce(() => {
    const id = new Date().getTime();

    if (generalPage.monogram?.monogramLetter?.length) {
      const { monogramLetter, monogramColor, monogramAnimationType } = generalPage.monogram;

      addMonogram({
        letter: monogramLetter,
        color: monogramColor,
        appearance: monogramAnimationType,
        id,
      });
    }

    return () => {
      clearMonogram(id);
    };
  });

  const isStandardPage = generalPage.meta.type === GENERAL_PAGE_TYPE.STANDARD;

  const renderPageContent = renderWhenTrueOtherwise(
    always(<ContentBody body={generalPage.body} />),
    always(
      <CenterContainer customStyles={alignContentTopStyles}>
        <ContentBody body={generalPage.body} hasSpacingTop={false} hasSpacingBottom={false} />
      </CenterContainer>
    )
  );

  return <Container>{renderPageContent(isStandardPage)}</Container>;
};
